/**
 * CLEARO cart nudge — "Add one more" button (snippets/clearo-cart-nudge.liquid).
 * Uses one document-level listener, because the cart drawer and cart page
 * replace their HTML on every change. Adds one unit of the given variant and
 * refreshes the cart drawer in place (or reloads the cart page).
 */
(() => {
  if (window.clearoCartNudge) return;
  window.clearoCartNudge = true;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-clr-nudge-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');

    const drawer = document.querySelector('cart-drawer');
    const inDrawer = drawer && drawer.contains(btn) && typeof drawer.renderContents === 'function';
    try {
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.clrNudgeAdd), quantity: 1 }],
          sections: inDrawer ? drawer.getSectionsToRender().map((s) => s.id) : undefined,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      if (inDrawer && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      console.error(err);
    }
  });
})();
